import { StarrableFieldsFragment } from "components/engagement/star/graphql/StarrableFieldsFragment";
import gql from "graphql-tag";

export const RemoveStarMutation = gql`
  mutation RemoveStar($input: RemoveStarInput!) {
    removeStar(input: $input) {
      ...StarrableFields
    }
  }
  ${StarrableFieldsFragment}
`;
